import React, { useRef, useEffect } from 'react';

const LINES = [
  { color: '#7c3aed', alpha: 0.90, amplitude: 55, freq: 0.0070, speed: 0.013, phase: 0.0,  width: 2.5 },
  { color: '#a78bfa', alpha: 0.75, amplitude: 40, freq: 0.0090, speed: 0.010, phase: 1.6,  width: 1.8 },
  { color: '#f472b6', alpha: 0.90, amplitude: 65, freq: 0.0065, speed: 0.016, phase: 3.2,  width: 2.5 },
  { color: '#22d3ee', alpha: 0.75, amplitude: 45, freq: 0.0080, speed: 0.009, phase: 4.8,  width: 1.8 },
  { color: '#6d28d9', alpha: 0.65, amplitude: 75, freq: 0.0055, speed: 0.007, phase: 6.4,  width: 3.2 },
  { color: '#ec4899', alpha: 0.60, amplitude: 30, freq: 0.0110, speed: 0.019, phase: 8.0,  width: 1.6 },
  { color: '#818cf8', alpha: 0.55, amplitude: 50, freq: 0.0075, speed: 0.011, phase: 9.6,  width: 1.8 },
];

export default function FlowingLines() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let animId;
    let t = 0;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const resize = () => {
      canvas.width  = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
      if (reduced) draw();
    };

    const buildPath = (line) => {
      ctx.beginPath();
      const cy = canvas.height * 0.5;
      for (let x = 0; x <= canvas.width + 2; x += 2) {
        const y = cy
          + Math.sin(x * line.freq + t * line.speed + line.phase) * line.amplitude
          + Math.sin(x * line.freq * 1.7 + t * line.speed * 0.6 + line.phase) * (line.amplitude * 0.3);
        x === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
      }
    };

    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      LINES.forEach(line => {
        /* Outer bloom — largo e morbido */
        buildPath(line);
        ctx.strokeStyle = line.color;
        ctx.lineWidth   = line.width * 6;
        ctx.shadowBlur  = 60;
        ctx.shadowColor = line.color;
        ctx.globalAlpha = line.alpha * 0.12;
        ctx.stroke();

        /* Mid glow */
        buildPath(line);
        ctx.strokeStyle = line.color;
        ctx.lineWidth   = line.width * 2.5;
        ctx.shadowBlur  = 30;
        ctx.shadowColor = line.color;
        ctx.globalAlpha = line.alpha * 0.35;
        ctx.stroke();

        /* Core line — nitida */
        buildPath(line);
        ctx.strokeStyle = line.color;
        ctx.lineWidth   = line.width;
        ctx.shadowBlur  = 20;
        ctx.shadowColor = line.color;
        ctx.globalAlpha = line.alpha;
        ctx.stroke();
      });

      ctx.globalAlpha = 1;
      ctx.shadowBlur  = 0;
      t++;
      if (!reduced) animId = requestAnimationFrame(draw);
    };

    resize();
    const ro = new ResizeObserver(resize);
    ro.observe(canvas);

    // Il glow con shadowBlur è costoso: si anima solo mentre la sezione è a schermo
    const io = new IntersectionObserver(([entry]) => {
      cancelAnimationFrame(animId);
      if (entry.isIntersecting) draw();
    });
    io.observe(canvas);

    return () => { cancelAnimationFrame(animId); ro.disconnect(); io.disconnect(); };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }}
    />
  );
}
